import { Skeleton } from '@/components/ui/skeleton';

const NewOrderPaymentSkeleton = () => {
	return (
		<div className='flex items-center gap-4'>
			<Skeleton className='size-8 rounded-semi-xl' />
			<div>
				<div className='h-6 flex items-center'>
					<Skeleton className='h-3 w-16 rounded-full' />
				</div>
				<div className='h-5 flex items-center'>
					<Skeleton className='h-3 w-30 rounded-full' />
				</div>
			</div>
			<Skeleton className='size-5 ml-auto rounded-full' />
		</div>
	);
};

export default NewOrderPaymentSkeleton;
